import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

export const adminProcessService = {
  getProcesses: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/admin/process`, getAxiosOptions(user))).data
  },
  createProcess: async (user, data) => {
    return (await axios.post(`${NODE_BASE_URL}/admin/process`, data, getAxiosOptions(user))).data
  },
  deleteProcess: async (user, processTemplateId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/process/${processTemplateId}`,
        getAxiosOptions(user),
      )
    ).data
  },
}
